import { ReactNode } from 'react'

import { useTheme } from '@mui/material'
import type { RoundScore } from '@/types/dde/teamHoleByHole.types'

import { EmptyHoleCells } from './EmptyHoleCells'
import { GolfHoleScore, HoleByHoleRowItem } from './styles'
import { EMPTY_VALUE, getHoleValue, getScoreBackground, getTextColor, RowHeaderType } from './utils'

interface GolfHoleByHoleCellsProps {
  rowData: RoundScore | null
  rowHeader: ReactNode
  isScoreRow: boolean
}

export const GolfHoleByHoleCells = ({
  rowData,
  rowHeader,
  isScoreRow
}: GolfHoleByHoleCellsProps) => {
  const theme = useTheme()
  const rowType = typeof rowHeader === 'string' ? (rowHeader as RowHeaderType) : null

  if (!rowData || !rowData.holes) {
    return <EmptyHoleCells />
  }

  const renderHoleItems = (start: number, end: number) => {
    return Array.from({ length: end - start + 1 }, (_, i) => {
      const holeNumber = start + i
      const hole = rowData.holes[holeNumber.toString()]
      if (!hole) {
        return (
          <HoleByHoleRowItem key={i}>
            <GolfHoleScore>{EMPTY_VALUE}</GolfHoleScore>
          </HoleByHoleRowItem>
        )
      }

      const holeScore = isScoreRow ? hole.holeScore : 0
      const background = getScoreBackground(holeScore, isScoreRow, theme)
      const textColor = getTextColor(background, theme)
      const value = getHoleValue(hole, rowType || (isScoreRow ? 'ROUND_ONE' : 'PAR'))

      return (
        <HoleByHoleRowItem key={i}>
          <GolfHoleScore background={background} textColor={textColor}>
            {value}
          </GolfHoleScore>
        </HoleByHoleRowItem>
      )
    })
  }

  return (
    <>
      {renderHoleItems(1, 9)}
      <HoleByHoleRowItem>
        <GolfHoleScore>{rowData.outScore?.par ?? EMPTY_VALUE}</GolfHoleScore>
      </HoleByHoleRowItem>
      {renderHoleItems(10, 18)}
      <HoleByHoleRowItem>
        <GolfHoleScore>{rowData.inScore?.par ?? EMPTY_VALUE}</GolfHoleScore>
      </HoleByHoleRowItem>
    </>
  )
}
